import React from 'react';
import {FormGroup, InputGroup} from 'react-bootstrap';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import SWTCarEditModal from '../../../view/workdoc/SWTCarEditModal';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
import {LoadCategoryOptions} from './FormUtils';
// import * as _ from 'lodash';

class SelectCarBrand extends React.Component {

  constructor(...args) {
    super(...args);
    this.initial();
    this.state = {
      modal: false,
    };
  }

  initial() {
    const {uiSchema} = this.props
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    try {
      LoadCategoryOptions(0).then((options) => {
        if(multi){
          options.splice(0, 0,{label:'ALL',value:0}) ;
        }
        this.props.setOption({
          brand_options: options,
      })});
    } catch (ex) {}
  }

  onFormChange = (e) => {
    // {
    //   brand_id: e.value,
    //       brand: e.label,
    // }
    const {uiSchema} = this.props
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    let evalue = multi?e:e;
    let evalue_search = multi?e:[e];
    this.props.onChange(evalue);
    
    if(evalue.length===1){
      LoadCategoryOptions(evalue_search[0].value).then((options) => {
        if(multi){
          options.splice(0, 0,{label:'---ทั้งหมด---',value:0}) ;
        }
        this.props.setOption({
          model_options: options,
          series_options: [],
        })
      });
    }else{
      this.props.setOption({
        model_options: [],
        series_options: [],
      })      
    }

  };


  openModal = () => {
    this.setState({modal: true});
  };

  closeModal = () => {
    this.setState({modal: false});
  };


  renderOption = (option) => {
    if(option.value===0){
      return (<span>{option.label}</span>)
    }
    return (
        <span><img
            alt=''
            src={'https://demo2.bigfix.co/korat/img/car_brand/' + option.label +
                 '-32x32.png'} /> {option.label}</span>
    );
  };

  render() {
    const {
      store,
      formData,
      uiSchema
    } = this.props;
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    
    return (
        <FormGroup>
          <InputGroup>
            <Select
                multi={multi}
                removeSelected={true}
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
                placeholder={'โปรดระบุ'}
                clearable={false}
                value={formData}
                options={store.options.brand_options}
                onChange={this.onFormChange}
                valueRenderer={this.renderOption}
                optionRenderer={this.renderOption}
            >
            </Select>
            <InputGroup.Addon
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
                className="btn"
                onClick={this.openModal}
            >
              <FontAwesome name="plus" />
            </InputGroup.Addon>
          </InputGroup>

          <SWTCarEditModal
              show={this.state.modal}
              onHide={this.closeModal}
          />
        </FormGroup>
    );
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectCarBrand);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectCarBrand.js